import { AnnouncementPopup } from "@9amhealth/shared";
import { useBlocNext } from "@blac/react";
import { AnimatePresence } from "framer-motion";
import { type FC, useCallback } from "react";
import { TrackEvent, TrackType } from "src/state/Track/TrackCubit";
import { tracker } from "src/state/state";
import Track from "src/ui/components/Track/Track";
import AnnouncementPopupCubit, {
  AnnouncementPopupController
} from "./AnnouncementPopupCubit";

const AnnouncementPopupOverlay: FC = () => {
  const [{ config }] = useBlocNext(AnnouncementPopupCubit);

  const handleConfirm = useCallback(() => {
    if (!config) {
      return;
    }
    tracker.track(TrackEvent.SophieAnnouncementPopupCTA, {
      type: TrackType.click,
      data: { action: "confirm" }
    });
    config.onConfirm();
    AnnouncementPopupController.dismiss();
  }, [config]);

  const handleCancel = useCallback(() => {
    if (!config) {
      return;
    }
    tracker.track(TrackEvent.SophieAnnouncementPopupCTA, {
      type: TrackType.click,
      data: { action: "cancel" }
    });
    config.onCancel();
    AnnouncementPopupController.dismiss();
  }, [config]);

  return (
    <AnimatePresence>
      {config && (
        <>
          <Track
            event={TrackEvent.SophieAnnouncementPopup}
            type={TrackType.open}
          />
          <AnnouncementPopup
            {...config}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
          />
        </>
      )}
    </AnimatePresence>
  );
};

export default AnnouncementPopupOverlay;
